export const PUERTO_RICO = "Puerto Rico";

export function isPuertoRico(state: string | null | undefined): boolean {
  return (state ?? "").trim() === PUERTO_RICO;
}

export function getPuertoRicoErrorMessage(
  translated: string | undefined,
  language: "en" | "es" = "en"
): string {
  return (
    translated ||
    (language === "es"
      ? "Actualmente no podemos atender a Puerto Rico."
      : "We're not able to serve Puerto Rico at this time.")
  );
}
